// extracted by mini-css-extract-plugin
module.exports = {"subheading":"SelectedEquipment_subheading__1ofiL","productHeading":"SelectedEquipment_productHeading__Sdm-L","container":"SelectedEquipment_container__1hGdc"};